import { Link } from 'react-router-dom';

export default function RegisterPage() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 pt-8 pb-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-extrabold text-text-primary mb-2">注册</h1>
          <p className="text-sm text-text-secondary">加入赛场，开始你的第一场对战</p>
        </div>

        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6">
          {/* Nickname */}
          <div className="mb-4">
            <label className="block text-xs font-medium text-text-secondary mb-1.5">昵称</label>
            <input type="text" placeholder="你的赛场ID" className="w-full h-10 px-3 rounded-btn bg-panel-mid/40 border border-border-dark text-sm text-text-primary placeholder:text-text-disabled focus:border-arena-blue focus:outline-none transition-colors" />
          </div>

          {/* Email */}
          <div className="mb-4">
            <label className="block text-xs font-medium text-text-secondary mb-1.5">邮箱</label>
            <input type="email" placeholder="your@email.com" className="w-full h-10 px-3 rounded-btn bg-panel-mid/40 border border-border-dark text-sm text-text-primary placeholder:text-text-disabled focus:border-arena-blue focus:outline-none transition-colors" />
          </div>

          {/* Password */}
          <div className="mb-4">
            <label className="block text-xs font-medium text-text-secondary mb-1.5">密码</label>
            <input type="password" placeholder="至少 8 位字符" className="w-full h-10 px-3 rounded-btn bg-panel-mid/40 border border-border-dark text-sm text-text-primary placeholder:text-text-disabled focus:border-arena-blue focus:outline-none transition-colors" />
          </div>

          {/* Confirm password */}
          <div className="mb-5">
            <label className="block text-xs font-medium text-text-secondary mb-1.5">确认密码</label>
            <input type="password" placeholder="再次输入密码" className="w-full h-10 px-3 rounded-btn bg-panel-mid/40 border border-border-dark text-sm text-text-primary placeholder:text-text-disabled focus:border-arena-blue focus:outline-none transition-colors" />
          </div>

          {/* Agreement */}
          <div className="flex items-start gap-2 mb-5">
            <input type="checkbox" className="mt-0.5 accent-arena-blue" />
            <span className="text-xs text-text-disabled leading-relaxed">
              我已阅读并同意 <span className="text-arena-blue hover:underline cursor-pointer">服务条款</span> 和 <span className="text-arena-blue hover:underline cursor-pointer">隐私政策</span>
            </span>
          </div>

          <button className="w-full h-10 rounded-btn bg-arena-blue text-white text-sm font-bold hover:brightness-110 transition-all mb-4">注册</button>

          <p className="text-center text-xs text-text-disabled">
            已有账号？<Link to="/login" className="text-arena-blue hover:underline">立即登录</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
